var _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.18018,
    width: 33,
    height: 33,
    rx: 3.5,
    fill: "#E6ECED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.18018,
    width: 33,
    height: 33,
    rx: 3.5,
    stroke: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9616 19.0005C14.9616 19.0005 11.2316 14.2005 9.2116 11.6105C8.7016 10.9505 9.1716 10.0005 10.0016 10.0005H23.9116C24.7416 10.0005 25.2116 10.9505 24.7016 11.6105C22.6816 14.2005 18.9616 19.0005 18.9616 19.0005V25.0005C18.9616 25.5505 18.5116 26.0005 17.9616 26.0005H15.9616C15.4116 26.0005 14.9616 25.5505 14.9616 25.0005V19.0005ZM21.9616 12.0005H11.9616L16.9516 18.3005L21.9616 12.0005Z",
    fill: "#587E85"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11.0005,
    r: 3.5,
    fill: "#EE4F4F",
    stroke: "#F2F3EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconDefault);
export default __webpack_public_path__ + "static/media/filter-icon-default.4d60c98186ad33667df2a372ad00d04c.svg";
export { ForwardRef as ReactComponent };